module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAcCAYAAAA0u3w+AAABa0lEQVRYR9XXvUoDQRSG4fdsbkD8SaWdCHZ6Bbam08pCEnvFTsQbEEGws7LK+lMIFl6EnYKdXoBVxoiNFhbZI7uRaCySnTHgnGl3mP0ezjBnRoh9pK4GnBQxk2Sb+uS1T2Txmfwvc1P3hOp08W+RDrDORvWybBZbwABk/MCz9gpZdoVqpVc1j0rGD8xVqVsDLkKQNoB/QNoBBiJtAQOQ9oCeSJtAD6RdYEmkbWAJpJA+z4Hug86Uvf7EN0/GgVlUvwuWXwZEVoWmuwddiC/0CBKJPObAV9CxESwX4RJyKzRbO4gc9pU3wqgBkT5IKkvdPXv+kj9Huk8Sa0M7dTq62R9b3klYplG9sX2Knro9Mj3ow4m8IdRyXPG6slawXt4SOLvAkjibQA+cPaAnzhYwAGcHGIizATx1W2R6PKgVDOoE8beJtNVGmeghfvW5YW3OANA9oDpfQDxxNrZo6haBoy/gLo2pu2FV+/n9E0J7u3Er9Ty5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/jt2.png
// module id = 5
// module chunks = 1